// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1653":"d7a43dfa","5678":"d34d5b9f","6856":"8716c76a"}[chunkId] + ".chunk.css";
};